import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {SettingsEmailMerge} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {Attachment} from '../types/email-data.types';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const $: any;

@Injectable()
export class SettingsEmailMergeService {
    isSettingsAmenitiesModalShow = false;
    isScheduleModalShow = false;
    isDisabledDatesModalShow = false;
    isLegalAgreementModalShow = false;
    isDisclaimerModalShow = false;
    showDetailedView = false;
    isPaymentModalShow = false;
    isViewAttachmentModalShow = false;
    firstTimeLoading = true;
    showNotificationsModal = false;
    selectedItemData: any;
    chosenCorporation: any;

    data = {
        total: null,
        corporations: {
            get: null,
            data: [],
            total: null
        }
    };
    tabId = 'allSettingsDirectory';
    spinnerShow = true;
    showServiceUnavailable = false;
    selectedItemFormattedBuildingsArray: Array<any> = [];
    activities: HistoryItem[];
    modalSpinnerShow = false;
    attachmentsToDisplay: Array<any> = [];
    serviceName: string = 'key_log';
    userRoles: Array<any> = [];
    keyCreatedStaffCheckbox = false;
    keyDeletedStaffCheckbox = false;
    keyModifiedStaffCheckbox = false;
    keySignedOutStaffCheckbox = false;
    keyReturnedStaffCheckbox = false;
    createdStaffMultiselectArray: Array<any> = [];
    deletedStaffMultiselectArray: Array<any> = [];
    modifiedStaffMultiselectArray: Array<any> = [];
    signedOutStaffMultiselectArray: Array<any> = [];
    returnedStaffMultiselectArray: Array<any> = [];
    showCorporationsList = true;
    bookingRequestModalNotificationType = '';

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService) {
    }

    resetData() {
        this.data.corporations.data = [];
        this.data.corporations.total = null;
        this.showDetailedView = false;
        this.selectedItemData = null;
        this.chosenCorporation = null;
    }

    toggleDetailedView(data, state: boolean): void {
        if (!data)
            this.selectedItemData.checked = false;
        this.selectedItemData = data ? data : null;
        if (state)
            this.getSettingsForCorporation(data.id);
        this.showDetailedView = state;
        if (this.selectedItemData) {
            for (const field in this.selectedItemData.formFields)
                this.selectedItemData.formFields[field].editMode = false;
        }
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }

    public getUserRoles() {
        const url = `/api/v1/role.json?per-page=1000`;
        this.api.get('oauthUrl', url).subscribe(
            res => {
                this.userRoles = [];
                const body = JSON.parse(res._body);
                body.entities.map(role => this.userRoles.push({id: role.id.toString(), itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    emptyNotificationArrays(): void {
        this.keyCreatedStaffCheckbox = false;
        this.keyDeletedStaffCheckbox = false;
        this.keyModifiedStaffCheckbox = false;
        this.keySignedOutStaffCheckbox = false;
        this.keyReturnedStaffCheckbox = false;

        this.createdStaffMultiselectArray = [];
        this.deletedStaffMultiselectArray = [];
        this.modifiedStaffMultiselectArray = [];
        this.signedOutStaffMultiselectArray = [];
        this.returnedStaffMultiselectArray = [];
    }

    getCorporations(scrollToTop?): void {
        this.getCorporationsByQueryParams(scrollToTop).subscribe();
    }

    getCorporationsByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        const queryParams = this.urlService.getQueryParamsString();
        const query = queryParams ? queryParams.slice(0, queryParams.indexOf('&order-by')) : '';
        const url = `/v1/corporation_number.json?${query}&order-by=name|asc&expand=reminders,settings,buildings`;
        return this.api.getJson('domainBD', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(),
                tap(({loading}) => this.spinnerShow = loading),
                tap(({finished}) => this.showCorporationsList = finished),
                tap(
                    (res) => {
                        this.data.corporations.data = res.entities;
                        this.data.corporations.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get corporations');
                    }
                )
            );
    }

    getSettingsForCorporation(corporationNumberId) {
        const corporationName = (<any>this.selectedItemData).name;
        const url = `/api/v1/corporation_number_service_settings/${corporationNumberId}.json`;
        this.api.get('domainEmails', url).subscribe(
            res => {
                this.selectedItemData = null;
                const body = JSON.parse(res._body);
                this.selectedItemData = body ? SettingsEmailMerge.fromExistingData(body) : new SettingsEmailMerge();
                this.selectedItemData.id = this.selectedItemData.corporationNumberId;
                this.selectedItemData.corporationNumberName = corporationName;
                // this.emptyNotificationArrays();
                // this.formatNotificationSettingsRoles();
            }, error => {
                if (error.statusText == 'Not Found') {
                    this.selectedItemData = new SettingsEmailMerge();
                    this.selectedItemData.id = corporationNumberId;
                    this.selectedItemData.corporationNumberName = corporationName;
                } else
                    this.api.errorHandler(error, 'Failed to get key log settings for the chosen corporation');
            }
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.forEach((notificationSetting) => {
                const propertyName = notificationSetting.action != 'signed_out' ? notificationSetting.action : 'signedOut';
                this['key' + (propertyName.charAt(0).toUpperCase() + propertyName.slice(1)) + 'StaffCheckbox'] = notificationSetting.enableStatus;
                notificationSetting.userRoles.forEach((role) => {
                    this[propertyName + 'StaffMultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.roleName
                    });
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-email-merge.service.ts